export const storeSourceTypeList = (state, sourceTypeList) => {
  state.sourceTypeList = [...sourceTypeList];
};
